import { Link } from "react-router-dom";

const NotFound = () => {
    return (
        <main className="relative overflow-hidden bg-zinc-950 text-white">
            <section className="relative isolate overflow-hidden pb-14 pt-24 sm:pt-28">
                <div
                    className="pointer-events-none absolute inset-0 opacity-80"
                    aria-hidden="true"
                    style={{
                        background:
                            "radial-gradient(circle at 20% 15%, rgba(225, 29, 72, 0.28), transparent 35%), radial-gradient(circle at 88% 12%, rgba(190, 24, 93, 0.22), transparent 32%), radial-gradient(circle at 80% 80%, rgba(244, 114, 182, 0.14), transparent 36%)",
                    }}
                />

                <div className="relative mx-auto flex min-h-[50vh] w-full max-w-6xl flex-col items-center justify-center px-4 text-center sm:min-h-[60vh] sm:px-6">
                    <span className="inline-flex rounded-full border border-rose-300/45 bg-rose-400/15 px-3 py-1 text-xs font-semibold uppercase tracking-[0.16em] text-rose-200">
                        Evento inexistente
                    </span>
                    <h2 className="mt-6 text-3xl font-black text-white sm:text-4xl">
                        Evento no encontrado
                    </h2>
                    <p className="mt-4 max-w-2xl text-lg leading-relaxed text-zinc-200">
                        El evento que buscas no existe o fue eliminado. Te dejamos
                        opciones para seguir explorando.
                    </p>
                    <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
                        <Link
                            to="/"
                            className="inline-flex rounded-xl bg-rose-600 px-6 py-3 text-sm font-bold uppercase tracking-[0.08em] text-white transition hover:scale-[1.02] hover:bg-rose-500"
                        >
                            Volver a eventos
                        </Link>
                        <Link
                            to="/"
                            className="inline-flex rounded-xl border border-zinc-100/35 bg-zinc-100/8 px-6 py-3 text-sm font-semibold uppercase tracking-[0.08em] text-zinc-100 backdrop-blur-sm transition hover:scale-[1.02] hover:bg-zinc-100/15"
                        >
                            Ir al inicio
                        </Link>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default NotFound;
